module.exports = __webpack_public_path__ + "static/media/box_hero.ccd87981.png";